module.exports = __webpack_public_path__ + "img/maincube_1.de1fd3f6.jpg";